export default function quickstartAppExplorerActiveFileChanged(context, payload) {
    context.dispatch('QUICKSTART_APP_EXPLORER_ACTIVE_FILE_CHANGED', payload);
}
